import React from 'react';

const PartnerLogos = () => {
  const partners = [
    { name: 'Enerviva', src: '/images/Enerviva-removebg-preview.png' },
    { name: 'Lunardi e Forni', src: '/images/LOGO_BIANCO_LUNARDI_E_FORNI-removebg-preview.png' },
    { name: 'CDNI', src: '/images/logo-CDNI-quadrato-e1765553223786.webp' },
    { name: 'Sky', src: '/images/sky-removebg-preview.png' },
    { name: 'Edison', src: '/images/edison-removebg-preview.png' },
    { name: 'A2A', src: '/images/logo-a2a-removebg-preview.png' },
    { name: 'Acea', src: '/images/acea-removebg-preview.png' },
    { name: 'Audax', src: '/images/audax-removebg-preview.png' },
    { name: 'Axpo', src: '/images/axpo-removebg-preview.png' },
    { name: 'Eni Plenitude', src: '/images/eniplenitude-removebg-preview.png' },
    { name: 'Eolo', src: '/images/eolo.png' },
    { name: 'Estra', src: '/images/estra-logo-v2.png' },
    { name: 'Fastweb', src: '/images/fastweb-removebg-preview.png' },
    { name: 'GNE', src: '/images/gne-removebg-preview.png' },
    { name: 'Hera', src: '/images/hera-removebg-preview.png' },
    { name: 'Illumia', src: '/images/illumia-md.png' },
    { name: 'Power4U', src: '/images/power4u-removebg-preview.png' },
    { name: 'Pulse', src: '/images/pulse-removebg-preview.png' },
    { name: 'Sorgenia', src: '/images/Sorgeniabn-removebg-preview.png' },
    { name: 'TIM', src: '/images/tim.png' },
    { name: 'Wind Tre', src: '/images/wind-tre-2020-logo-png_seeklogo-410091.png' },
    { name: 'EDP', src: '/images/thumb_edp_generico-removebg-preview.png' },
  ];

  // Duplicate the array to create the infinite loop effect
  const duplicatedPartners = [...partners, ...partners];

  return (
    <div className="mt-16 bg-brand-primary py-12 overflow-hidden w-full">
      <div className="container mx-auto px-4 mb-8">
        <h3 className="text-2xl font-bold text-center text-white">I Nostri Partner</h3>
      </div>
      <div className="relative w-full">
        {/* Gradients for fading effect on sides */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-brand-primary to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-brand-primary to-transparent z-10 pointer-events-none"></div>
        
        <div className="flex animate-scroll hover:pause whitespace-nowrap w-max gap-12 px-4">
          {duplicatedPartners.map((partner, index) => (
            <div 
              key={`${partner.name}-${index}`} 
              className="w-[200px] min-w-[200px] h-32 p-4 transition-all flex items-center justify-center mx-4"
            >
              <img 
                src={partner.src} 
                alt={`${partner.name} logo`} 
                className="max-h-24 max-w-full object-contain transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerLogos;
